import { Locale } from "lib/Intl";
import { Trans } from "@lingui/macro";
import { Accordion } from "src/atoms/Accordion";
import { Done } from "src/icons/Done";
import { ThuiswinkelWaarborgIcon } from "src/icons/ThuiswinkelWaarborgIcon";
import { AccordionHeading } from "src/molecules/ProductMeta/ProductMeta.styled";
import { Miscellaneous } from "src/types/graphql.d";

const ProductMetaDescription = ({
  locale,
  onOpen,
  miscellaneousData,
  ...rest
}: {
  locale: Locale;
  onOpen?: () => void;
  miscellaneousData?: Miscellaneous;
}): JSX.Element => (
  <Accordion.Panel
    onOpen={onOpen}
    className="ProductMeta__accordionPanel"
    {...rest}
  >
    <Accordion.Title>
      <AccordionHeading>
        <Trans>Otrium offers</Trans>
      </AccordionHeading>
    </Accordion.Title>
    <Accordion.Content>
      {!!miscellaneousData?.pdp?.otriumOffers?.length && (
        <ul className="ProductMeta__offers">
          {miscellaneousData?.pdp?.otriumOffers?.map((offer, index) => (
            <li className="ProductMeta__offer" key={`product-meta-${index}`}>
              <Done className="ProductMeta__offerIcon" />
              <span
                data-testid="product-meta-offer-text"
                className="ProductMeta__offerText"
              >
                {offer}
              </span>
            </li>
          ))}
        </ul>
      )}
      {["en", "nl"].includes(locale) && (
        <ThuiswinkelWaarborgIcon className="ProductMeta__paymentThuiswinkelWaarborg" />
      )}
    </Accordion.Content>
  </Accordion.Panel>
);

export default ProductMetaDescription;
